import { render } from "./TelemetryView.vue?vue&type=template&id=55b64242"
import script from "./TelemetryView.vue?vue&type=script&lang=js"
export * from "./TelemetryView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__